import { render } from "./FilterSkeleton.vue?vue&type=template&id=1bb2217c"
import script from "./FilterSkeleton.vue?vue&type=script&lang=js"
export * from "./FilterSkeleton.vue?vue&type=script&lang=js"

import "./FilterSkeleton.vue?vue&type=style&index=0&id=1bb2217c&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__